import { useHomeTabs } from '../../queries/useHomeTabs';
import { TabBar, TabBarItem, TabView } from 'react-native-tab-view';
import { useMemo, useState } from 'react';
import {
  Colors,
  RemoteImage,
  Typography,
  useScreenSize,
} from '@banhala/ui-kit';
import type { HomeTabItem } from 'shared/src/api';
import { HomeAtomic } from '../HomeAtomic/HomeAtomic';
import { isNotNil } from 'shared/src/utils';
import { HomeWebView } from '../HomeWebView';

export type HomeTabRoute = {
  key: string;
  title: string;
} & HomeTabItem;

export const HomeContents = () => {
  const { data: homeTabs } = useHomeTabs();
  const [index, setIndex] = useState(
    homeTabs.item_list.findIndex(item => item.id === homeTabs.selected_id),
  );
  const size = useScreenSize();

  const routes = useMemo<HomeTabRoute[]>(() => {
    return (
      homeTabs.item_list?.map(item => ({
        ...item,
        key: item.id,
        title: item.name,
      })) ?? []
    );
  }, [homeTabs.item_list]);

  if (homeTabs.item_list.length === 0) return null;

  return (
    <TabView<HomeTabRoute>
      lazy={true}
      navigationState={{ index, routes }}
      renderScene={item => {
        if (item.route.type === 'ATOMIC') {
          return (
            <HomeAtomic
              screenName={item.route.screen_name}
              nextToken={item.route.default_query?.next_token}
            />
          );
        }

        if (item.route.type === 'WEBVIEW') {
          return <HomeWebView url={item.route.default_query?.url} />;
        }

        return <Typography>{item.route.title}</Typography>;
      }}
      onIndexChange={setIndex}
      initialLayout={{
        width: size.width,
      }}
      // renderTabBar={props => <HomeTabBar {...props} />}
      renderTabBar={props => (
        <TabBar
          {...props}
          tabStyle={{
            width: 'auto',
          }}
          scrollEnabled={true}
          renderTabBarItem={props => {
            // props.route.render.
            if (isNotNil(props.route.render)) {
              if (isNotNil(props.route.render.overlay_image)) {
                return (
                  <RemoteImage
                    uri={props.route.render.overlay_image}
                    width={100}
                    height={50}
                  />
                );
              }
              return (
                <TabBarItem
                  {...props}
                  key={props.route.key}
                  activeColor={props.route.render.selected_text_color}
                  inactiveColor={props.route.render.text_color}
                />
              );
            }
            return (
              <TabBarItem
                {...props}
                activeColor={Colors.content_primary}
                inactiveColor={Colors.content_secondary}
              />
            );
          }}
          indicatorStyle={{ backgroundColor: Colors.content_primary }}
          style={{ backgroundColor: Colors.bg_always_white }}
        />
      )}
    />
  );
};
